import {publishTrackEvent} from "../.."

const TrackFacetSelection = (facetCategory: string, facetOption: string) => {
    publishTrackEvent("facet", {
        facet: {
            category: "facet",
            action: "select",
            label: facetCategory,
            option: facetOption,
        },
    })
}

export default TrackFacetSelection
